//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";


export const Styles = makeStyles((theme) => ({
  searchInput: {
    width: 400,
    borderRadius: 20,
    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  searchInputIcon: {
    cursor: "pointer",
  },
  topGrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  greenBtn: {
    backgroundColor: "green",
    padding: "2px 12px",
    borderRadius: 20,
    color: "white",
    fontWeight: "bold",
  },
  redBtn: {
    backgroundColor: "red",
    padding: "2px 12px",
    borderRadius: 20,
    color: "white",
    fontWeight: "bold",
  },
  blackBtn: {
    backgroundColor: "gray",
    padding: "2px 12px",
    borderRadius: 20,
    color: "white",
    fontWeight: "bold",
  },
  // Dialog
  dialogParentDiv: {
    padding: 25,
  },
  parentText: {
    fontSize: 25,
  },
  parentText2: {
    fontSize: 20,
    textAlign:"center"
  },
  parentText3: {
    fontSize: 20,
    textAlign:"center",
    marginTop:"5%"
  },
  parentText2Note: {
    fontSize: 16,
    fontWeight: "bold",
    color: "gray",
  },
  parentText3Note: {
    fontSize: 18,
    fontWeight: "bold",
    color: "black",
    display:"block",
    textAlign:"center"
  },
  subParentHeader: {
    color: "#595959",
    fontSize: 18,
    textAlign: "center",
  },
  subParentBody: {
    textAlign: "center",
  },
  cancelBtn: {
    color: "#305698",
    backgroundColor: "#fff",
    border: "2px solid #305698",
    borderRadius: 10,
    fontSize: 20,
    textTransform: "capitalize",
  },
  proceedBtnGrid: {
    textAlign: "right",
  },
  proceedBtn: {
    color: "#fff",
    backgroundColor: "#305698",
    borderRadius: 10,
    fontSize: 20,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#305698",
    },
  },
  blukUploadBtn: {
    color: "#fff",
    backgroundColor: "#0a72ba",
    borderRadius: 5,
    fontSize: 14,
    padding: "4px 8px",
    border: "none",
    cursor: "pointer",
    height: 30,
    marginRight: "10px"
  },
  updateDialogLoader: {
    textAlign: "center",
  },
  td: {
    border: "2px solid #dddddd",
    textAlign: "left",
    padding: "8px",
    backgroundColor: "#fff"
  },
  tdiv: {
    margin:"25px",
    marginLeft:"15%"
  },
  exportBtn: {
    color: "#fff",
    width: 60,
    height: 30,
    cursor: "pointer",
    borderRadius: 5,
    backgroundColor: "#0a72ba",
    border: "none"   
  },
}));